import 'd3-transition';
import isEqual from 'lodash/fp/isEqual';
import { memo, FC } from 'react';

import Wrapper from './Wrapper';
import { useDrawLineChart } from './hooks';
import { ChartLineProps } from './types';

export * from './types';

const ChartLine: FC<ChartLineProps> = props => {
  const chartRef = useDrawLineChart(props);

  return <Wrapper ref={chartRef} />;
};

const MemorizedChartLine = memo(ChartLine, isEqual);

export default MemorizedChartLine;
